// extracted by mini-css-extract-plugin
module.exports = {"fieldsetLabel":"ColorPicker_fieldsetLabel__3mKzF","optionColor":"ColorPicker_optionColor__3rjfN","colorBox":"ColorPicker_colorBox__3f2mR"};